export default __webpack_public_path__ + "static/media/rare_perfect.cef99543.jpg";